import {API_URL_CATALOG} from "../urls";

// GET requests

const getCategoriesKidsApi = () => {
  return window.axios

    .get(
      API_URL_CATALOG +
        "product/category/list/v1/get?productCategoryCodeKeyword=STUDENTS_PRODUCT"
    )

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        return data.createdEntity.listOfProductCategory;
      }

      throw new Error(data.message);
    })

    .catch((error) => {
      throw error;
    });
};

export { getCategoriesKidsApi };
